<template>
  <i class="fas" :class="icon.iconClass" :style="'color: ' + icon.color"></i>
</template>
<script>
import {prioritiesMixin} from '@/mixins/priorities.js';

export default {
  props: ['priority'],
  mixins: [prioritiesMixin],
  data: function() { return { }},
  computed: {
    icon() {
      return this.getPriorityFromValue(this.priority)
    }
  }
}
</script>